/** @format */

import {ChartLabelValue, CommonChartData} from '../../model/charts';

import {DIGIT_WIDTH, OFFSET_CENTER, OFFSET_DOWN, OFFSET_UP} from './constants';

export interface Options {
  data: CommonChartData[];
  index: number;
  key: keyof CommonChartData;
}

/**
 * Вернёт параметры подписи для точки графика
 * Если подпись не нужна, то вернёт undefined
 * @param data
 * @param key
 * @param index
 */

const getChartLabelValue = ({data, key, index}: Options): ChartLabelValue | undefined => {
  // Не выводим, если значение отсутствует
  const currentValue = data[index]?.[key];
  if (currentValue === undefined || typeof currentValue !== 'number') {
    return;
  }

  const result: ChartLabelValue = {
    value: currentValue,
    show: true,
    offsetY: OFFSET_UP,
  };

  // Выводим, если значение в начале списка
  // Смещаем подпись влево и по центру относительно точки

  const previousValue = data[index - 1]?.[key];
  if (previousValue === undefined || typeof previousValue !== 'number') {
    const digitsCount = String(currentValue).length;
    result.offsetX = Math.round((digitsCount * DIGIT_WIDTH) / 2 + DIGIT_WIDTH / 2);
    result.offsetY = OFFSET_CENTER;
    return result;
  }

  // Выводим, если значение в конце списка
  // Смещаем подпись вправо и по центру относительно точки

  const nextValue = data[index + 1]?.[key];
  if (nextValue === undefined || typeof nextValue !== 'number') {
    const digitsCount = String(currentValue).length;
    result.offsetX = -Math.round((digitsCount * DIGIT_WIDTH) / 2 + DIGIT_WIDTH);
    result.offsetY = OFFSET_CENTER;
    return result;
  }

  // Не выводим, если разница между предыдущим и текущим = 0

  if (previousValue === currentValue) {
    return;
  }

  // Выводим, если разница между следующим и текущим = 0, а между текущим и предыдущим отлична от нуля

  const diffWithNext = nextValue - currentValue;
  const diffWithPrevious = currentValue - previousValue;

  if (diffWithNext === 0 && diffWithPrevious !== 0) {
    result.offsetY = diffWithPrevious < 0 ? OFFSET_DOWN : OFFSET_UP;
    return result;
  }

  // Выводим, если между предыдущей разницей и текущей поменялся знак
  // Доп: определить позицию лейбла

  const isPit = diffWithNext > 0 && diffWithPrevious < 0;
  const isPeak = diffWithNext < 0 && diffWithPrevious > 0;

  if (isPeak) {
    return result;
  }

  if (isPit) {
    result.offsetY = OFFSET_DOWN;
    return result;
  }
};

export {getChartLabelValue};
